<template>
  <div v-if="generalLoading" class="loadingFinalPracite">
    <Loader />
  </div>
  <div v-if="componentReady" class="courseStructure">

    <Disclaimer v-if="data.status === 'PUBLISHED'" />

    <h1 v-html="$t('courseStructure.MAKE_COPY_OF_MASTER_COURSE')"></h1>

    <h5>{{ $t('courseStructure.STEP_NUMBER', { number: 3 }) }}</h5>
    <h3>{{ $t('courseStructure.COURSE_STRUCTURE') }}</h3>

    <div class="add_unit">
      <span>{{ $t('courseStructure.CONTENTS') }}</span>
      <button :disabled="data.status === 'PUBLISHED'" @click="newUnitModel.modalActive = true">
        <i class="material-icons-outlined">add_circle</i> {{ $t('courseStructure.ADD_UNIT') }}
      </button>
      <!-- <button ><i class="material-icons-outlined">add_circle</i> Agregar unidad</button> -->
    </div>

    <Modal :isOpen="newUnitModel.modalActive" @close="newUnitModel.modalActive = false" >
      <div style="gap: 18px;" class="intervalPublication"> 
        <h3 style="font-size: 16px;" class="intervalPublication__title">{{ $t('courseStructure.ADD_UNIT') }}</h3>
        <Input 
          id="newUnit"
          :label="$t('courseStructure.UNIT_NAME')"
          v-model="newUnitModel.name"
        />
        <div class="intervalPublication__buttons">
          <button @click="emptyModuleModel();" class="intervalPublication__button">{{ $t('global.CANCEL') }}</button>
          <button @click="addUnit(); emptyUnitModel()" class="intervalPublication__button">{{ $t('global.SAVE') }} <i class="material-icons-outlined">arrow_forward</i></button>
        </div>
      </div>
    </Modal>

    <div class="courseStructure__units">
      <div v-for="(unit, unitIdx) in units" :key="unitIdx" class="courseStructure__unit">
        <div class="courseStructure__unit_title">
          <label class="courseStructure__unit_name" :for="`unit${unitIdx}`">
            <span>{{ unit.name }}</span>
            <div class="courseStructure__unit_actions">
              <i :title="$t('courseStructure.EDIT_TITLE')" @click="editUnitNameModel[unitIdx] = unit.name" class="material-icons-outlined">edit</i>
              <!-- <i title="Copiar unidad" @click="copyUnit(unitIdx)" class="material-icons-outlined">content_copy</i> -->
              <!-- <i title="Copiar unidad" class="material-icons-outlined">content_copy</i> -->
              <!-- <i title="Agregar módulo" class="material-icons-outlined">post_add</i> -->
              <i 
              :title="$t('courseStructure.ADD_MODULE')" 
              @click="data.status !== 'PUBLISHED' && (newModuleModal[unitIdx] = true)"
              class="material-icons-outlined"
              :class="{ 'icon-disabled': data.status === 'PUBLISHED' }"
              >
                post_add
              </i>
              <!-- <i title="Eliminar unidad" class="material-icons-outlined">delete</i> -->
              <i 
              :title="$t('courseStructure.DELETE_UNIT')"
              @click="data.status !== 'PUBLISHED' && (removeUnitModal[unitIdx] = true)" 
              class="material-icons-outlined"
              :class="{ 'icon-disabled': data.status === 'PUBLISHED' }"
              >
                delete
              </i>
            </div>
          </label>
        </div>

        <!-- MODAL EDITAR NOMBRE DE LA UNIDAD -->
        <Modal :isOpen="editUnitNameModel[unitIdx]" @close="editUnitNameModel[unitIdx] = false" >
          <div class="intervalPublication"> 
            <h3 class="intervalPublication__title">{{ $t('courseStructure.EDIT_UNIT_NAME') }}</h3>
            <Input 
              id="newUnit"
              :label="$t('courseStructure.UNIT_NAME')"
              v-model="editUnitNameModel[unitIdx]"
            />
            <div class="intervalPublication__buttons">
              <button @click="editUnitNameModel[unitIdx] = false" class="intervalPublication__button">{{ $t('global.CANCEL') }}</button>
              <button @click="saveUnitName(unitIdx)" class="intervalPublication__button">{{ $t('global.SAVE') }} <i class="material-icons-outlined">arrow_forward</i></button>
            </div>
          </div>
        </Modal>

        <Modal :isOpen="removeUnitModal[unitIdx]" @close="removeUnitModal[unitIdx] = false">
          <div class="removeUnit">
            <!-- <h2>{{ $t('courseStructure.CONFIRM_DELETE_UNIT', { unitName: unit.name }) }}</h2> -->
             <!-- v-html -->
            <h2 v-html="$t('courseStructure.CONFIRM_DELETE_UNIT', { unitName: unit.name })"></h2>
            <span>{{ $t('courseStructure.DELETE_UNIT_WARNING') }}</span>
            <div class="removeUnit__buttons">
              <button @click="removeUnitModal[unitIdx] = false" class="removeUnit__cancel">{{ $t('global.CANCEL') }}</button>
              <button :disabled="submitting" @click="removeUnit(unitIdx)" class="removeUnit__delete">{{ $t('courseStructure.DELETE_UNIT_BUTTON') }}</button>
            </div>
          </div>
        </Modal>

        <!-- MODAL NUEVO MODULO -->
        <Modal :isOpen="newModuleModal[unitIdx]" @close="emptyModuleModel(); newModuleModal[unitIdx] = false">
          <div class="intervalPublication"> 
            <h3 class="intervalPublication__title">{{ $t('courseStructure.ADD_NEW_MODULE') }}</h3>
            <Input 
              id="newModule"
              :label="$t('courseStructure.MODULE_NAME')"
              v-model="newModuleModel.name"
              :isError="v$.newModuleModel.name.required.$invalid && newModuleModal.submitted"
              :errorMessage="$t('courseStructure.MODULE_NAME_REQUIRED')"
              />
            <!-- <Select 
              mode="simple"
              label="Tiempo de publicación"
              id="publicationTime"
              :values="[1, 2, 3, 4, 5]"
              v-model="newModuleModel.time"
            /> -->
            <div class="intervalPublication__buttons">
              <button @click="emptyModuleModel(); newModuleModal[unitIdx] = false" class="intervalPublication__button">{{ $t('global.CANCEL') }}</button>
              <button :disabled="submitting"  @click="addModule(unitIdx);" class="intervalPublication__button">{{ $t('global.SAVE') }} <i class="material-icons-outlined">arrow_forward</i></button>
            </div>
          </div>
        </Modal>

        <!-- TABLE MODULOS DE LA UNIDAD  -->

        <div class="table__scroll">
          <div :style="{ paddingBottom: unit.modules.length ? '0' : '12px' }" class="table">
            <div class="table__titles">
              <div style="width: 80px;" class="table__title"></div>
              <div style="width: 230px;" class="table__title">{{ $t('courseStructure.MODULE') }}</div>
              <div style="width: 185px;" class="table__title table__title--publicacion">
                {{ $t('courseStructure.PUBLICATION') }}
                <i class="material-icons-outlined">info</i>
                <div class="tooltip">
                  <h5>{{ $t('courseStructure.PUBLICATION') }}</h5>
                  <p>{{ $t('courseStructure.PUBLICATION_TOOLTIP') }}</p>
                </div>
              </div>
              <div style="width: 185px;" class="table__title"></div>
              <div style="width: 180px;" class="table__title"></div>
            </div>

            <div v-if="!unit.modules.length" class="emptyState">
              <i class="material-icons">error</i>
              {{ $t('courseStructure.UNIT_HAS_NO_CONTENT') }}
              <!-- <strong>Agrega un módulo</strong> -->
            </div>
            <draggable  
              :list="unit.modules" 
              group="a" 
              handle=".drag-handle" 
              item-key="module"
              @start="dragStart($event)"
              @end="dragFinished()"
              v-bind="dragOptions"
              class="draggable-item"
              :scroll-sensitivity="200"
              :force-fallback="true"
            >
              <template #item="{element: content, index: contentIdx}">
                <div class="table__row">
                  <div style="width: 80px;" :class="{ 'drag-handle': data.status !== 'PUBLISHED' }" :style="{ opacity: data.status === 'PUBLISHED' ? 0.1 : 1, cursor: data.status === 'PUBLISHED' ? 'default' : 'pointer' }">
                    <i style="display: flex; align-items: center; font-size: 24px; cursor: pointer; justify-content: center;" class="material-icons-outlined table__data">drag_indicator</i>
                  </div>
                  <span style="width: 230px;" class="table__data">M{{ contentIdx + 1 }} - {{content.name}}</span>
                  <span style="width: 185px;" class="table__data">
                    {{ content.publicationInterval === 0 ? 'Inicio del curso' : `${content.publicationInterval} Dias` }}
                  </span>
                  <button :disabled="submitting" @click="editContent(content.id)" style="width: 185px;" class="courseStructure__editContent table__data">{{ $t('courseStructure.EDIT_CONTENT') }}</button>
                  <div style="width: 180px;" @click="moreOptionsOpen[`u${unitIdx}c${contentIdx}`] = !moreOptionsOpen[`u${unitIdx}c${contentIdx}`]" ref="moreOptions" class="table__options table__data" >
                    <i  class="material-icons">more_vert</i><!--Más opciones-->
                    <transition name="fade">
                      <div 
                        v-if="moreOptionsOpen[`u${unitIdx}c${contentIdx}`]" 
                        class="table__modal-options"
                      >
                        <div 
                          @click="moduleConfigurationModel.name = content.name; moduleConfigurationModel.interval = content.publicationInterval; moduleConfigurationModal[`${unitIdx}-${contentIdx}`] = true"
                        >
                          <i class="material-icons-outlined">mode</i>
                          {{ $t('courseStructure.EDIT_CONFIGURATION') }}
                        </div>
                        <!-- <div  @click="copyModule(unitIdx)" >
                          <i class="material-icons-outlined">content_copy</i>Copiar módulo
                        </div>-->
                        <div 
                          @click="data.status !== 'PUBLISHED' && (deleteModuleModal[`u${unitIdx}c${contentIdx}`] = true)"
                          :style="{ cursor: data.status === 'PUBLISHED' ? 'not-allowed' : 'pointer', pointerEvents: data.status === 'PUBLISHED' ? 'none' : 'all', opacity: data.status === 'PUBLISHED' ? 0.5 : 1 }"
                        >
                          <i class="material-icons-outlined">delete_outline</i> {{ $t('global.DELETE') }}
                        </div>
                      </div>
                    </transition>
                  </div>

                  <Modal v-if="moduleConfigurationModal[`${unitIdx}-${contentIdx}`]" :isOpen="moduleConfigurationModal[`${unitIdx}-${contentIdx}`]" @close="moduleConfigurationModal[`${unitIdx}-${contentIdx}`] = false">
                    <div class="intervalPublication">
                      <h3 class="intervalPublication__title">{{ $t('courseStructure.MODULE_CONFIGURATION') }}</h3>
                      <Input 
                        :label="$t('courseStructure.MODULE_NAME')"
                        id="module_name"
                        v-model="moduleConfigurationModel.name"
                        :isError="v$.moduleConfigurationModel.name.required.$invalid"
                        :errorMessage="$t('global.FIELD_REQUIRED')"
                        />
                      <Input 
                        type="number"
                        id="interval"
                        v-model="moduleConfigurationModel.interval"
                        :label="$t('courseStructure.PUBLICATION_INTERVAL_DAYS')"
                        :isError="v$.moduleConfigurationModel.interval.required.$invalid"
                        :disabled="data.status === 'PUBLISHED'"
                        :errorMessage="$t('global.FIELD_REQUIRED')"
                        :supportText="$t('courseStructure.PUBLICATION_INTERVAL_SUPPORT_TEXT')"
                        />


                      <div class="intervalPublication__buttons">
                        <button @click="cleanModuleConfigurationModel(); moduleConfigurationModal[`${unitIdx}-${contentIdx}`] = false" class="intervalPublication__button">{{ $t('global.CANCEL') }}</button>
                        <button 
                          @click="changeModuleConfiguration(unitIdx, contentIdx)" 
                          class="intervalPublication__button"
                        >
                        {{ $t('global.SAVE') }} <i class="material-icons-outlined">arrow_forward</i>
                        </button>
                      </div>
                    </div>
                  </Modal>

                  <Modal :isOpen="deleteModuleModal[`u${unitIdx}c${contentIdx}`]" @close="deleteModuleModal[`u${unitIdx}c${contentIdx}`] = false">
                    <div class="removeUnit">
                      <!-- <h2>{{ $t('courseStructure.CONFIRM_DELETE_MODULE', { moduleName: content.name }) }}</h2> -->
                       <!-- v-html -->
                      <h2 v-html="$t('courseStructure.CONFIRM_DELETE_MODULE', { moduleName: content.name })"></h2>
                      <span>{{ $t('courseStructure.DELETE_MODULE_WARNING') }}</span>
                      <div class="removeUnit__buttons">
                        <button @click="deleteModuleModal[`u${unitIdx}c${contentIdx}`] = false" class="removeUnit__cancel">{{ $t('global.CANCEL') }}</button>
                        <button :disabled="submitting" @click="deleteModule(unitIdx, contentIdx)" class="removeUnit__delete">{{ $t('courseStructure.DELETE_MODULE_BUTTON') }}</button>
                      </div>
                    </div>
                  </Modal>

                </div>
              </template>
            </draggable>
          </div>  

        </div>

      </div>

    </div>

    <div style="display: flex; align-items: center; gap: 12px; padding: 0 24px; align-self: flex-start; margin-top: 24px;">
      <span style="font-size: 20px; font-weight: 700;">{{ $t('courseStructure.PRACTICE_WITH_STUDENTS') }}</span>
      
      <div
      :class="{ active: isActive }"
      class="toggle-button"
      @click="(data.status !== 'PUBLISHED' && data.courseType != 1) ? toggleFinalPractice() : ''"
      :style="{ cursor: (data.status === 'PUBLISHED' || data.courseType == 1) ? 'not-allowed' : 'pointer' }"
      >
        <div class="toggle-handle">
        </div>
        <div class="tooltip" v-if="data.courseType == 1"><p>{{ $t('courseStructure.ON_DEMAND_NO_PRACTICE') }}</p></div>

      </div>
    </div>

    <div v-if="finalPractices !== null" class="table">
      <div class="table__titles">
        <div style="width: 80px;" class="table__title"></div>
        <div style="width: 230px;" class="table__title">{{ $t('courseStructure.TYPE') }}</div>
        <div style="width: 185px;" class="table__title table__title--publicacion">
          {{ $t('courseStructure.PUBLICATION') }}
          <i class="material-icons-outlined">info</i>
          <div class="tooltip">
            <h5>{{ $t('courseStructure.PUBLICATION') }}</h5>
            <p>{{ $t('courseStructure.PUBLICATION_TOOLTIP') }}</p>
          </div>
        </div>
        <div style="width: 185px;" class="table__title"></div>
        <div style="width: 180px;" class="table__title"></div>
      </div>
      <div v-if="!finalPractices.modules.length" class="emptyState">
        <i class="material-icons">error</i>
        {{ $t('courseStructure.NO_PRACTICE_ASSOCIATED') }}
      </div>
      <draggable v-else :list="finalPractices.modules" group="b" handle=".drag-handle" item-key="module" :scroll-sensitivity="200" :force-fallback="true">
        <template #item="{ element: content}">
          <div class="table__row">
            <div  style="width: 80px;" class="drag-handle">
            </div>
            <span style="width: 230px;" class="table__data">{{ translateFinalPracticeName(content.type) }}</span>
            <span style="width: 185px;" class="table__data">
              {{ content.publicationInterval == 0 ? $t('courseStructure.COURSE_START') : $t('courseStructure.WEEKS_INTERVAL', { weeks: content.publicationInterval }) }}
          </span>
            <button 
              style="width: 180px;" 
              class="courseStructure__editContent table__data"
              @click="editContent(content.id, content.type)"
            >
              Editar contenido
            </button>
            <div style="width: 185px;"></div>
          </div>
        </template>
      </draggable>
    </div>  

    
    <div class="buttons">
      <button @click="router.push('information')" class="button__backward"><i class="material-icons-outlined">arrow_back</i> Atrás</button>
      <button :disabled="submitting" @click="submit" class="button__forward">Continuar<i class="material-icons-outlined">arrow_forward</i></button>
    </div>
  </div>
</template>

<script>
import { computed, onMounted, ref } from 'vue';
import Modal from '@/components/Modal.vue';
import Input from '@/components/Input.vue';
import draggable from 'vuedraggable';
import { useStore } from 'vuex';
import { required } from '@vuelidate/validators';
import useVuelidate from '@vuelidate/core';
import { useRouter, useRoute } from 'vue-router';
import { onClickOutside } from '@vueuse/core';
import Loader from '../../../components/Loader.vue';
import Disclaimer from './Disclaimer.vue';
import { useI18n } from 'vue-i18n';


export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  components: {
    Modal,
    Input,
    draggable,
    Loader,
    Disclaimer
},
  setup(props, { emit }) {
    const units = ref()
    const finalPractices = ref()
    const moreOptions = ref()
    const moreOptionsOpen = ref({})
    const newModuleModal = ref({})
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const submitting = ref(false)
    const deleteModuleModal = ref({})
    const generalLoading = ref(false)
    const moduleConfigurationModal = ref({})
    const moduleConfigurationModel = ref({
      name: '',
      interval: ''
    })
    const isActive = ref(false)
    const componentReady = ref(false)
    const newModuleModel = ref({
      name: '',
      time: '',
      submitted: false
    })
    const newUnitModel = ref({
      modalActive: false,
      publicationinterval: ''
    })
    const intervalTypes = ref([
      {
        name: 'Inicio del curso',
        interval: 0
      },
      {
        name: '1 Semana',
        interval: 1
      },
      {
        name: '2 Semanas',
        interval: 2
      },
      {
        name: '3 Semanas',
        interval: 3
      }
    ])
    const v$ = useVuelidate()
    const editUnitNameModel = ref({})
    const removeUnitModal = ref({})

    const { t } = useI18n();


    const cleanModuleConfigurationModel = () => moduleConfigurationModel.value = { name: '', interval: '' }

    const emptyUnitModel = () => newUnitModel.value = { modalActive: false, name: '' }

    const emptyModuleModel = () => newModuleModel.value = { name: '', time: '', submitted: false }


    const toggleFinalPractice = async () => {

      if (isActive.value) {
        generalLoading.value = true
        finalPractices.value = null
        await save()
        isActive.value = false
        generalLoading.value = false
      }
      

      else {
        if (generalLoading.value) return
        generalLoading.value = true
        isActive.value = true
        finalPractices.value = {
          name: 'Práctica con tus estudiantes',
          orderNumber: 0,
          modules: [{
            name: 'Práctica con tus estudiantes',
            orderNumber: 1,
            publicationInterval: 0,
            type: 'Trip'
          }]
        }

        const data = await save()
        finalPractices.value = data.finalPractice
        generalLoading.value = false
      }
    }

    const copyModule = idx => {
      units.value[idx].modules.push({
        module: 'Introducción',
        publication: "Inicio del curso",
        publicationinterval: 3
      })
    }

    const removeUnit = async idx => {
      await save()
      units.value.splice(idx, 1)
      removeUnitModal.value[idx] = false
    }

    const addModule = async (idx) => {
      if (submitting.value) return
      if (!newModuleModel.value.name.trim().length) {
        newModuleModal.value.submitted = true
        return
      }
      else {
        try {
          submitting.value = true
          let newUnits = units.value
          newUnits[idx].modules.push({
            name: newModuleModel.value.name,
            publicationInterval: 0
          })
          let body = {
            units: newUnits,
            courseCfgId: props.data.courseCfgId,
            finalPracticeUnit: finalPractices.value
          }
          const { data: newStructure } = await store.dispatch('courses_cfgthirdStep', body)
          units.value = newStructure.units
        } catch (err) {
          console.log(err)
          store.dispatch('notifications_create', { text: t('courseStructure.ERROR_ADDING_MODULE') });
        } finally {
          submitting.value = false
        }
        newModuleModal.value[idx] = false
        emptyModuleModel()
      }
    }

    const changeModuleConfiguration = async (unit, module) => {
      if (v$.value.moduleConfigurationModel.name.required.$invalid || v$.value.moduleConfigurationModel.interval.required.$invalid) return;

      if (props.data.status === 'PUBLISHED') {
        try {
          await store.dispatch('courses_moduleCfgRename', {
            moduleCfgId: units.value[unit].modules[module].id,
            newName: moduleConfigurationModel.value.name,
            courseId: props.data.courseCfgId
          });
          store.dispatch('notifications_create', { text: t('courseStructure.MODULE_NAME_UPDATED') });
        } catch (error) {
          console.error('Error updating module configuration:', error);
          // Handle error (e.g., show notification)
          store.dispatch('notifications_create', { text: t('courseStructure.ERROR_UPDATING_MODULE_NAME') });
          return;
        }
      }

      units.value[unit].modules[module].name = moduleConfigurationModel.value.name;
      units.value[unit].modules[module].publicationInterval = moduleConfigurationModel.value.interval;
      moduleConfigurationModal.value[`${unit}-${module}`] = false;
      cleanModuleConfigurationModel();
    };


    const editContent = async (id, type = undefined) => {
      if (submitting.value) return;
      try {
        submitting.value = true;

        // Create a mapping for status
        const statusMapping = {
          'PUBLISHED': 'A1',
          'DRAFT': 'B2',
          // ... other statuses
        };

        // Get the coded status value
        const codedStatus = statusMapping[props.data.status] || 'unknown';

        // If the status is not 'A1', then dispatch the 'thirdStep'
        if (codedStatus !== 'A1') {
          let body = {
            units: units.value,
            courseCfgId: props.data.courseCfgId,
            finalPracticeUnit: finalPractices.value
          };
          await store.dispatch('courses_cfgthirdStep', body);
        }

        // Construct the URL with the coded status
        let url = `/contents/mastercourses/${route.params.courseCfgId}/moduleeditor/${id}?s=${codedStatus}`;
        if (type !== undefined) {
            url += `&type=${type}`;
        }

        router.push(url);
      } catch (err) {
        console.log(err);
      } finally {
        submitting.value = false;
      }
    };





    // const translateFinalPracticeName = internalName => {
    //   if (!internalName) {
    //     return '---';
    //   }

    //   switch (internalName.toUpperCase()) {
    //     case 'TRIP':
    //       return 'Trip';
    //     case 'CONTENTSHARE':
    //       return 'Práctica situada';
    //   }
    // }
    const translateFinalPracticeName = internalName => {
      if (!internalName) {
        return '---';
      }

      switch (internalName.toUpperCase()) {
        case 'TRIP':
          return t('courseStructure.TRIP');
        case 'CONTENTSHARE':
          return t('courseStructure.CONTENT_SHARE');
        default:
          return internalName;
      }
    }


    const saveUnitName = async idx => {
      if (editUnitNameModel.value[idx].trim().length === 0) {
        store.dispatch('notifications_create', { text: t('courseStructure.EMPTY_NAME_ERROR') });
        return;
      }

      if (props.data.status === 'PUBLISHED') {
        try {
          await store.dispatch('courses_unitCfgEditName', {
            unitCfgId: units.value[idx].id,
            newName: editUnitNameModel.value[idx].trim(),
            courseId: props.data.courseCfgId
          });
          // alert('Nombre de unidad actualizado');
          store.dispatch('notifications_create', { text: t('courseStructure.UNIT_NAME_UPDATED') });
        } catch (error) {
          console.error('Error saving unit name:', error);
          // Handle error (e.g., show notification)
          store.dispatch('notifications_create', { text: t('courseStructure.ERROR_UPDATING_UNIT_NAME') });

          return;
        }
      }

      // alert('Nombre de unidad actualizado');

      units.value[idx].name = editUnitNameModel.value[idx].trim();
      editUnitNameModel.value[idx] = false;
    };

    
    const deleteModule = async (unitIdx, contentIdx) => {
      await save()
      units.value[unitIdx].modules.splice(contentIdx)
    }

    const copyUnit = idx => {
      let unitToCopy = units.value[idx]
      units.value.push(unitToCopy)
    }

    const save = async () => {
      if (submitting.value) return
      try {
        submitting.value = true
        let body = {
          units: units.value,
          courseCfgId: props.data.courseCfgId,
          finalPracticeUnit: finalPractices.value
        }
        if (props.data.status !== 'PUBLISHED') {
          const { data } = await store.dispatch('courses_cfgthirdStep', body)
          return data
        } else {
          return props.data
        }
      }   catch (err) {
        console.log(err)
      } finally {
        submitting.value = false
      }
    }

    const submit = async () => {
      if (submitting.value) return;

      try {
        let data = await save();
        emit('changeData', data);

        // Determine the query parameter based on the status
        let queryParam = '';
        if (props.data.status === 'PUBLISHED') {
          queryParam = '?s=A1';
        } else if (props.data.status === 'DRAFT') {
          queryParam = '?s=B2';
        }

        // Navigate to the next route with the appropriate query parameter
        router.push(`certificate${queryParam}`);
      } catch (err) {
        console.log(err);
        store.dispatch('notifications_create', { text: t('courseStructure.ERROR_SAVING') });
      }
    };


    const addUnit = () => {
      units.value.push({
        name: newUnitModel.value.name.trim() || `Unidad ${units.value.length + 1}`,
        modules: []
      })
    }

    
    
    const drag = ref(false);
    
    const dragFinished = async () => {
      generalLoading.value = true
      await save()
      drag.value = false
      generalLoading.value = false
    }

    const dragOptions = computed(() => ({
      animation: 200,
      group: "description",
      disabled: false,
      ghostClass: "ghost"
    }));


    const dragStart = (event) => {
  drag.value = true;
  
  const item = event.item; // This is the dragged element
  const scrollHeight = 10;
  const scrollTriggerDistance = 100; // distance from edge to start scrolling

  const scrollUp = () => {
    window.scrollBy(0, -scrollHeight);
  };

  const scrollDown = () => {
    window.scrollBy(0, scrollHeight);
  };

  const scrollInterval = setInterval(() => {
    if (drag.value) {
      const updatedItemRect = item.getBoundingClientRect();

      // Calculate the distance from the top and bottom of the viewport to the item
      const distanceFromTop = updatedItemRect.top;
      const distanceFromBottom = window.innerHeight - updatedItemRect.bottom;

      if (distanceFromTop <= scrollTriggerDistance) {
        // Start scrolling up when the item is within 100px of the viewport's top
        scrollUp();
      } else if (distanceFromBottom <= scrollTriggerDistance) {
        // Start scrolling down when the item is within 100px of the viewport's bottom
        scrollDown();
      }
    } else {
      clearInterval(scrollInterval);
    }
  }, 10);
};


    const dragEnd = () => {
      drag.value = false;
    };



    onClickOutside(moreOptions, () => moreOptionsOpen.value = {})

    onMounted(() => {
      units.value = props.data.units
      finalPractices.value = props.data.finalPractice
      if(props.data.courseType == 1) finalPractices.value = null;
      isActive.value = finalPractices.value !== null
      componentReady.value = true
    })

    return {
      units,
      moreOptionsOpen,
      newModuleModal,
      newModuleModel,
      v$,
      newUnitModel,
      editUnitNameModel,
      removeUnitModal,
      isActive,
      componentReady,
      router,
      finalPractices,
      moreOptions,
      moduleConfigurationModal,
      intervalTypes,
      moduleConfigurationModel,
      submitting,
      deleteModuleModal,
      generalLoading,

      emptyModuleModel,
      addModule,
      deleteModule,
      addUnit,
      saveUnitName,
      copyModule,
      emptyUnitModel,
      copyUnit,
      removeUnit,
      dragOptions,
      cleanModuleConfigurationModel,
      changeModuleConfiguration,
      submit,
      dragStart,
      dragEnd,
      editContent,
      toggleFinalPractice,
      dragFinished,
      translateFinalPracticeName
    }
  },
  validations() {
    return {
      newModuleModel: {
        name: { required },
      },
      moduleConfigurationModel: {
        name: { required },
        interval: { required }
      }
    }
    
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.button {
  margin-top: 35px;
}

.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: rgba($color: #009691, $alpha: 0.1);
}

.loadingFinalPracite{
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba($color: #000000, $alpha: 0.1);
  z-index: 9999;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: move;
}

.list-group-item i {
  cursor: pointer;
}
.buttons{
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;
  margin-top: 24px;
  .button{
      text-align: center;
      width: fit-content;
      display: flex;
      align-items: center;
      gap: 12px;
      border-radius: 999px;
      padding: 12px 18px;
      &__forward{
        @extend .button;
        color: #fff;
        background-color: $green;
      }
      &__backward{
        @extend .button;
        border: 1px solid $green;
        color: $green;
        background-color: inherit;
      }
      &:disabled{
        cursor: default;
        opacity: .6;
      }
  }
}
.emptyState{
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  padding: 30px 22px;
  background-color: #FFB23F26;
  margin: 6px 0;
  .material-icons{
    color: #FFB23F;
    font-size: 22px;
  }
}
.toggle-button {
  position: relative;
  width: 40px;
  height: 16px;
  background-color: #ccc;
  border-radius: 15px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s;
  &:hover{
    .tooltip{
      visibility: visible;
      opacity: 1;
      top: -20px;
      right: -212px;
    }
  }
}

.toggle-button.active {
  background-color: #9ed7d7;
}

.toggle-handle {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
  transition: all 0.3s;
}

.active{
  .toggle-handle {
    transform: translateX(22px);
    background-color: $green;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: all 0.2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
.fade-enter-active {
  animation: appear .2s;
}
@keyframes appear {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.add_unit{
  font-size: 20px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  width: 100%;
  margin-bottom: 24px;
  button{
    color: $green;
    display: flex;
    align-items: center;
    text-align: center;
    gap: 6px;
    font-weight: 600;
    font-size: 14px;
    .material-icons-outlined{
      font-size: 16px;
    }
  }
}

.removeUnit{
  width: 550px;
  display: flex;
  flex-direction: column;
  gap: 30px;
  align-items: center;
  padding: 0 80px;
  text-align: center;
  h2{
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    strong{
      font-size: 18px;
      font-style: italic;
      font-weight: 700;
      color: $green;
    }
  }
  span{
    font-size: 18px;
    font-weight: 400;
  }
  &__buttons{
    display: flex;
    align-items: center;
    margin: 0 auto;
    gap: 12px;
  }
  &__cancel{
    border: none;
    background-color: inherit;
    color: #000;
    font-size: 16px;
    font-weight: 600;
  }
  &__delete{
    background-color: $red;
    color: #fff;
    border: none;
    border-radius: 44px;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.15);
    padding: 16px 24px;
    font-size: 16px;
    font-weight: 600;
  }
}

.intervalPublication{
  padding: 24px;
  width: 420px;
  display: flex;
  flex-direction: column;
  gap: 22px;
  padding-top: 0;
  &__title{
    font-size: 16px !important;
    font-weight: 700;
  }
  &__content{
    font-size: 15px;
    color: $green;
  }
  &__module{
    font-size: 13px;
    font-weight: 700;
  }
  &__buttons{
    display: flex;
    align-items: center;
  }
  &__button{
    border: none;
    font-size: 16px;
    font-weight: 600;
    padding: 12px 16px;
    width: 210px;
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    border-radius: 999px;
    justify-content: center;
    &:first-child{
      color: $green;
    }
    &:last-child{
      background-color: $green;
      color: #ffF;
      .material-icons-outlined{
        font-size: 16px;
      }
    }
  }
}
.courseStructure{
  padding: 28px 0;
  max-width: 985px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  >h1{
    font-size: 24px;
    font-weight: 800;
    text-align: center;
  }
  >h3{
    font-size: 20px;
    font-weight: 600;
    text-align: center;
  }
  >h5{
    font-size: 14px;
    font-style: normal;
    font-weight: 800;
    text-align: center;
  }
  &__units{
    display: flex;
    flex-direction: column;
    gap: 40px;
    max-width: 985px;
    width: 100%;
  }
  &__editContent{
    font-family: "Open Sans";
    font-size: 16px;
    font-weight: 600;
    color: $green;
    text-align: start;
  }
  &__unit{
    display: flex;
    flex-direction: column;
    gap: 12px;
    max-width: 985px;
    width: 100%;
    &_actions{
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 10px 16px;
      border: 1px solid $green;
      border-radius: 999px;
    }
    &_title{
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      padding: 0 24px;
    }
    &_name{
      display: flex;
      align-items: center;
      gap: 14px;
      font-size: 16px;
      font-weight: 700;
      input{
        border: none;
        outline: none;
        font-size: 16px;
        font-weight: 700;
        &:disabled{
          font-size: 16px;
          color: #212121;
          background-color: inherit;
        }
      }
      .material-icons, .material-icons-outlined{
        cursor: pointer;
        font-size: 18px;
        color: $green;
      }
    }
    &_add{
      display: flex;
      align-items: center;
      color: $green;
      font-size: 16px;
      font-weight: 600;
      gap: 8px;
      .material-icons-outlined{
        cursor: pointer;
        color: $green;
        font-size: 18px;
      }
    }
  }
}

.tooltip {
  visibility: hidden;
  width: 200px;
  background-color: #BDE4E4;
  color: #212121;
  text-align: left;
  border-radius: 10px;
  padding: 16px;
  position: absolute;
  z-index: 1;
  right: 50px;
  top: 24px;
  margin-left: 5px;
  opacity: 0;
  transition: opacity 0.3s;

  h5 {
    font-size: 12px;
    font-weight: 700;
    margin-bottom: 4px;
  }

  p {
    font-size: 11px;
    font-weight: 400;
  }

}


.table{
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.10);
  width: 100%;
  max-width: 985px;
  padding: 23px;
  padding-bottom: 0;
  border-radius: 10px;
  &__titles{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &__title{
    padding: 0 24px;
    font-size: 12px;
    font-weight: 700;

    &--publicacion {
      position: relative;

      .material-icons-outlined {
        font-size: 12px;
      }

      &:hover .tooltip {
        visibility: visible;
        opacity: 1;
      }
    }

  }

  &__row{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-bottom: .5px solid #BDBDBD;
    &:last-child{
      border-bottom: none;
    }
  }
  &__data{
    padding: 24px;
    font-size: 16px;
    font-weight: 400;
    display: flex;
    align-items: center;

    @media (max-width:980px) {
      width: 100%!important;
      padding: 8px;
    }
  }
  &__options {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
  }
  &__modal-options {
    position: absolute;
    top: 55px;
    right: -24px;
    min-width: 215px !important;
    display: flex;
    flex-direction: column;
    gap: 8px;
    background: #fff;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    z-index: 8000;
    padding: 6px 0;
    >div {
      padding: 4px 22px;
      @include icon-and-text-container;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
      padding: 4px 22px;
      &:hover {
          background: rgba(189, 228, 228, 0.5);
      }
    }
  }
}

.icon-disabled {
  cursor: not-allowed!important;
  color: #ccc!important;
}




</style>